import { defineStore } from "pinia";
import { ref } from "vue";
import { API } from "@/queries/index";
import { AxiosError } from "axios";
import { APIResponse, APIResponseError } from "@/types/api";
import { handleResponse, handleResponseError } from "@/utils/api";
import { PortPayload, PortResponse } from "@/types/interface/port";

export const usePortStore = defineStore("portStore", () => {
  const port = ref<PortResponse>();
  const ports = ref<PortResponse[]>([]);

  function initPorts(data: any) {
    ports.value = data?.data;
  }

  function addNewPort(data: any) {
    port.value = data;
  }

  async function dispatchGetAll(page = 1, limit = 10, queryParam = "") : Promise<APIResponse<null>> {
    try {
      const { status, data } = await API.port.getPort(page, limit, queryParam);
      if (status === 200 ) {
        initPorts(data);
        return handleResponse(status, data);
      }
    } catch (error) {
      const _error = error as AxiosError<APIResponseError>;
      const errorResponseData = _error.response?.data
      return handleResponseError(errorResponseData)
    }
    return handleResponse(200, null);
  }

  async function dispatchDetail(idUnit = "") : Promise<APIResponse<null>> {
    try {
      const { status, data } = await API.port.findPort(idUnit);
      if (status === 200 ) {
        addNewPort(data);
        return handleResponse(status, data);
      }
    } catch (error) {
      const _error = error as AxiosError<APIResponseError>;
      const errorResponseData = _error.response?.data
      return handleResponseError(errorResponseData)
    }
    return handleResponse(200, null);
  }

  async function dispatchCreate(payload: PortPayload) : Promise<APIResponse<null>> {
    try {
      const { status, data } = await API.port.createPort(payload);
      if (status === 200 ) {
        addNewPort(data);
        return handleResponse(status, data);
      }
    } catch (error) {
      const _error = error as AxiosError<APIResponseError>;
      const errorResponseData = _error.response?.data
      return handleResponseError(errorResponseData)
    }
    return handleResponse(200, null);
  }

  async function dispatchUpdate(idUnit = "", payload: PortPayload) : Promise<APIResponse<null>> {
    try {
      const { status, data } = await API.port.updatePort(idUnit, payload);
      if (status === 200 ) {
        addNewPort(data);
        return handleResponse(status, data);
      }
    } catch (error) {
      const _error = error as AxiosError<APIResponseError>;
      const errorResponseData = _error.response?.data
      return handleResponseError(errorResponseData)
    }
    return handleResponse(200, null);
  }

  async function dispatchDelete(idUnit = "") : Promise<APIResponse<null>> {
    try {
      const { status, data } = await API.port.deletePort(idUnit);
      if (status === 200 ) {
        return handleResponse(status, data);
      }
    } catch (error) {
      const _error = error as AxiosError<APIResponseError>;
      const errorResponseData = _error.response?.data
      return handleResponseError(errorResponseData)
    }
    return handleResponse(200, null);
  }

  return {
    port,
    ports,
    initPorts,
    dispatchCreate,
    dispatchUpdate,
    dispatchDetail,
    dispatchGetAll,
    dispatchDelete
  };
});